
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Eye'
})
export default class Eye extends Vue {}
